import React, { useEffect } from "react";
import BaseLayout from "layouts/base";
import RenderModules from "components/render-modules";
import Filters from "components/collection/filters";
import CollectionNavigation from "components/collection/navigation";
import ProductsList from "components/collection/products-list";
import PriceRangeSlider from "components/price-range-slider";
import { useFilters, useSettings } from "hooks/useStore";
import CollectionMobileNav from "components/collection/mobile-nav";
import FiltersSlidePane from "components/collection/filters-slide-pane";
import ClearAllFilters from "components/clear-filters";
import RichText from "components/rich-text";
import PaginationRange from "components/collection/pagination-range";
import { ReactComponent as FilterIcon } from "assets/svgs/filter.svg";
import Sorting from "components/collection/sorting";
import clsx from "clsx/lite";
import PromoBanner from "components/collection/promo-banner";
export { Head } from "components/head";

const Collection = ({ pageContext, location }) => {
	const { visible: visibleFilters, toggleVisibility } = useFilters(["visible", "toggleVisibility"]);
	const { pageLoading } = useSettings(["pageLoading"]);

	const {
		modules, title, handle, description, products, defaultSort, settings, secureCheckout, previewSettings = {} } = pageContext;
	const { populateFilters, collections } = useFilters(["populateFilters", "collections"]);
	const tags = handle in collections ? collections[handle] : null;

	const collectionFilters = collections[handle];
	const sortBy = collectionFilters?.sortBy || defaultSort || "best-selling";

	const priceRange = {
		min: Math.min(...products.map(product => product.minVariantPrice)),
		max: Math.max(...products.map(product => product.minVariantPrice)),
	};

	useEffect(() => {
		if (!tags) populateFilters(handle, settings.filters, priceRange, defaultSort);
	}, []);
	return (
		<BaseLayout previewSettings={previewSettings}>
			<div className="collection-page">
				<div className="pb-5 lg:py-5 standard-section-width mx-auto collection-container horizontal-padding">
					<div className={clsx("collection-v2", pageLoading && "collection-v2-loading")}>
						<h1 className="my-3 text-center lg:text-left md:text-h2 text-h3-xs pb-4">{title}</h1>
						<PaginationRange handle={handle} />
						<div className="flex justify-between items-center">
							<button className="hidden md:flex gap-2 items-center t-toggle-filters-panel" onClick={toggleVisibility}>
								<span className="text-secondary">{visibleFilters ? `Hide` : "Show"} filters</span>
								<FilterIcon />
							</button>
							<Sorting handle={handle} value={sortBy} />
						</div>
					</div>
					<div className="flex">
						<div className={clsx("hidden lg:w-1/4 lg:block transition-all",
							pageLoading && "filters-loading-v2",
							visibleFilters ? "lg:w-1/4" : "lg:!w-0 lg:h-0 opacity-0")}>
							<ClearAllFilters handle={handle} />
							<CollectionNavigation navigation={settings.navigation} handle={handle} />
							{priceRange.max - priceRange.min > 200 &&
								<PriceRangeSlider
									handle={handle}
									minValue={priceRange.min}
									maxValue={priceRange.max}
									location={location} />}
							<Filters data={settings.filters} handle={handle} products={products} />
						</div>
						<div className={clsx("w-full transition-all",
							pageLoading && "results-loading-v2", visibleFilters ? "lg:w-3/4" : "lg:w-full")}>
							<CollectionMobileNav handle={handle} links={settings.mobileNavigation} />
							<FiltersSlidePane
								priceRange={priceRange}
								navigation={settings.navigation}
								filters={settings.filters}
								handle={handle}
								products={products}
								location={location} />
							<h1 className="my-3 text-center lg:text-left md:text-h2 text-h3-xs collection-v1">{title}</h1>
							<ProductsList collection={{ products, title, handle, defaultSort }} 
								secureCheckout={secureCheckout} promoCard={settings.promoCard} />
						</div>
					</div>
				</div>
				{settings.globalPLPModules && <RenderModules modules={settings.globalPLPModules} />}
				<div className=" standard-section-width mx-auto collection-container horizontal-padding">
					{settings.promoBanner?.enabled && <PromoBanner data={settings.promoBanner} />}
					{description &&
						<div className="my-10 md:my-20">
							<RichText data={{ content: description }} showReadMore />
						</div>
					}
				</div>
				{modules && <RenderModules modules={modules} />}
			</div>
		</BaseLayout>
	);
};

export default Collection;











